const AI_ROLE_BUILDER_STATUS = {
  INITIALIZED: "Agent Task Initialized",
  COMPLETED: "Agent Task Completed",
  FAILED: "Agent Task Failed",
  DISCARDED: "Agent Task Discarded",
};

// Helper to check if status is in processing state
// Any status that is NOT "COMPLETED" is considered a processing state
// This allows new statuses from DS to automatically be treated as processing
const isProcessingStatus = (status) => status !== AI_ROLE_BUILDER_STATUS.COMPLETED;

// Helper to check if status is completed
const isTaskCompleted = (status) => status === AI_ROLE_BUILDER_STATUS.COMPLETED;

// Helper to check if status is failed
const isTaskFailed = (status) => status === AI_ROLE_BUILDER_STATUS.FAILED;

// AI Role Builder Modal Step Constants
const AI_ROLE_BUILDER_STEP = {
  INPUT: "input",
  PROCESSING: "processing",
  SUCCESS: "success",
};

// Polling configuration
const AI_ROLE_BUILDER_CONFIG = {
  POLLING_INTERVAL: 5000, // 5 seconds - poll until terminal status
  STORAGE_KEY: "aiRoleBuilderJob",
};

const AI_ROLE_INTERVIEW_QUESTIONS_CONFIG = {
  STORAGE_KEY: "aiRoleInterviewQuestions",
  POLLING_INTERVAL: 4000,
};

// Queue configuration. No STORAGE_KEY: the queue is server-backed, so it rehydrates
// from `aiRoleBuilderTasks` rather than from localStorage.
const AI_ROLE_BUILDER_TASKS_CONFIG = {
  POLLING_INTERVAL: 5000,
  DESCRIPTION_PREVIEW_LENGTH: 120,
};

// Our own lifecycle, as the AiRoleBuilderTaskStatusEnumType names the API sends. `status`
// on the legacy single-job payload is the agent's stage instead — AI_ROLE_BUILDER_STATUS.
const AI_ROLE_BUILDER_TASK_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  DISCARDED: "DISCARDED",
};

// Derived UI states for a queued task, mirroring getVideoTaskDisplayState
// in aiVideoInterviewStatuses.js
const AI_ROLE_BUILDER_TASK_DISPLAY_STATE = {
  PROCESSING: "processing",
  READY: "ready",
  ERROR: "error",
};

const isTaskDiscarded = (status) => status === AI_ROLE_BUILDER_TASK_STATUS.DISCARDED;

/**
 * Reduces a queued task to the single state the queue row renders from.
 *
 * @param {Object} task  A task returned by the aiRoleBuilderTasks query
 * @returns {string}     One of AI_ROLE_BUILDER_TASK_DISPLAY_STATE
 */
const getRoleBuilderTaskDisplayState = (task) => {
  if (task?.status === AI_ROLE_BUILDER_TASK_STATUS.FAILED) return AI_ROLE_BUILDER_TASK_DISPLAY_STATE.ERROR;
  if (task?.status === AI_ROLE_BUILDER_TASK_STATUS.COMPLETED) return AI_ROLE_BUILDER_TASK_DISPLAY_STATE.READY;

  return AI_ROLE_BUILDER_TASK_DISPLAY_STATE.PROCESSING;
};

const isTaskPolling = (task) => task?.status === AI_ROLE_BUILDER_TASK_STATUS.IN_PROGRESS;

export default AI_ROLE_BUILDER_STATUS;

export {
  AI_ROLE_BUILDER_CONFIG,
  AI_ROLE_BUILDER_TASK_STATUS,
  AI_ROLE_BUILDER_TASKS_CONFIG,
  AI_ROLE_BUILDER_TASK_DISPLAY_STATE,
  AI_ROLE_INTERVIEW_QUESTIONS_CONFIG,
  AI_ROLE_BUILDER_STEP,
  getRoleBuilderTaskDisplayState,
  isProcessingStatus,
  isTaskCompleted,
  isTaskDiscarded,
  isTaskFailed,
  isTaskPolling,
};
